import { render, staticRenderFns } from "./SelectedOfferBox.vue?vue&type=template&id=44f4b220"
import script from "./SelectedOfferBox.vue?vue&type=script&lang=js"
export * from "./SelectedOfferBox.vue?vue&type=script&lang=js"
import style0 from "./SelectedOfferBox.vue?vue&type=style&index=0&id=44f4b220&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports